  import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "./RevokeOpenJob.scss";
import Reasonselect from "../../Common/DropDown/DropDown";
import { 
  FormControl, 
  InputLabel, 
  MenuItem, 
  Select, 
  Box, 
  Typography, 
  TextField, 
  Button, 
  IconButton,
  Paper,
  Chip,
  Alert
} from "@mui/material";
import { setJobModal } from "../../../redux/userReducer";
import graphqlRequest from "../../../requestMethod";
import eventHelpers from "../../../Helpers/Event";
import { pushEvent } from "../../../utils/clevertap";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
  function RevokeOpenJob({
    revokeMiniJobOffers,
    keepMiniJobOffers,
    jobPostRemoveId,
    setRevokeConfirmation,
    revokeId,
    setRevokeId,
    reasonToRemove,
    setReasonToRemove,
  }) {
    // let [reasonToRemove, setReasonToRemove] = useState({
    //   reason: "",
    //   comment: "",
    // });

    let [reasonToRemoveError, setReasonToRemoveError] = useState({});

    function validate() {
      let error = {};
      if (!reasonToRemove.reason) {
        error.reason = "Please select one reason";
      }
      if (reasonToRemove?.reason === "Others") {
        if (!reasonToRemove.comment) {
          error.comment = "Please provide reason to remove";
        } else if (reasonToRemove.comment.length < 8) {
          error.comment = "Please provide valid comment (min 8 chars)";
        }
      }
      // if (!reasonToRemove.comment) {
      //   error.comment = "please provide reason to remove";
      // }
      // if (reasonToRemove.comment.length < 8) {
      //   error.comment = "please provide valid comment";
      // }
      if (revokeId == "") {
        error.comment = "Please provide valid revoke reason";
      }
      return error;
    }

    useEffect(() => {
      setReasonToRemoveError(validate());
    }, [reasonToRemove]);

    // Set default revokeId to "All Offer" when component mounts
    useEffect(() => {
      if (!revokeId) {
        setRevokeId("All Offer");
        setReasonToRemove(prev => ({
          ...prev,
          revoke: "All Offer"
        }));
      }
    }, [revokeId]);

    let dispatch = useDispatch();
    function revokeAllOffer() {
      revokeMiniJobOffers(jobPostRemoveId?.id);
      setRevokeConfirmation(false);
      // dispatch(setJobModal());
      setReasonToRemove({ reason: "", comment: "", revoke: "" });
    }
    function revokePendingPosition() {
      keepMiniJobOffers(jobPostRemoveId?.id);
      setRevokeConfirmation(false);
      setReasonToRemove({ reason: "", comment: "", revoke: "" });
      // dispatch(setJobModal());
    }

    function handleJobPost(jobType) {
      pushEvent("Web_Cancel_OpenJob_Discard", {
            page: "Open Job",
            section: "Jobs",
            ...jobPostRemoveId,
          });
      // dispatch(setJobModal());
      setRevokeConfirmation(false);
      setReasonToRemove({ reason: "", comment: "", revoke: "" });
    }

    // const [revokeId, setRevokeId] = useState("");

    const fetchUserId = async () => {
      let data = localStorage.getItem("auth");
      let token = JSON.parse(data)?.accessToken;
      try {
        const query = `
      query {
        withAuth(token: "${token}"){
        userDetails{
          id,
          name {
            salutation
            first
            middle
            last
            full
          },
          emails {
            isPrimary
            isVerified
            address
          },
          phoneNumbers{
            number
          }
        }
        }
      }
        `;
        const response = await graphqlRequest(query);
        // console.log("175-->",response)
        return response;
      } catch (error) {
        console.error("Error sending GraphQL request:", error);
      }
    };

    // const trackCancelOpnLJbYes = async () => {
    //   const user = await fetchUserId();
    //   // console.log("user---->", user);
    //   const userId = user.data.withAuth.userDetails.id;
    //   const userName = user.data.withAuth.userDetails.name.full;
    //   const userEmail = user.data.withAuth.userDetails.emails[0].address;
    //   const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    //   if (window.Moengage) {
    //     //set unique id
    //     window.Moengage.add_unique_user_id(userId);
    //     //set user attributes
    //     window.Moengage.add_user_name(userName);
    //     window.Moengage.add_email(userEmail);
    //     window.Moengage.add_mobile(userPhone);

    //     //set event data
    //     window.Moengage.track_event(
    //       eventHelpers.CANCEL_OPN_L_JB_Y
    //       // {
    //       // "ID": userId,
    //       // "name": userName,
    //       // "Email": userEmail,
    //       // "date": Date.now(),
    //       //}
    //     );
    //     // window.Moengage.destroy_session();
    //   }
    // };

    // const trackCancelOpnLJbNo = async () => {
    //   const user = await fetchUserId();
    //   // console.log("user---->", user);
    //   const userId = user.data.withAuth.userDetails.id;
    //   const userName = user.data.withAuth.userDetails.name.full;
    //   const userEmail = user.data.withAuth.userDetails.emails[0].address;
    //   const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    //   if (window.Moengage) {
    //     //set unique id
    //     window.Moengage.add_unique_user_id(userId);
    //     //set user attributes
    //     window.Moengage.add_user_name(userName);
    //     window.Moengage.add_email(userEmail);
    //     window.Moengage.add_mobile(userPhone);

    //     //set event data
    //     window.Moengage.track_event(
    //       eventHelpers.CANCEL_OPN_L_JB_N
    //       // {
    //       // "ID": userId,
    //       // "name": userName,
    //       // "Email": userEmail,
    //       // "date": Date.now(),
    //       //}
    //     );
    //   }
    //   }
 


  const trackCancelOpnLJbYes = async () => {
    const user = await fetchUserId();
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      window.Moengage.add_unique_user_id(userId);
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      window.Moengage.track_event(
        eventHelpers.CANCEL_OPN_L_JB_Y
      );
    }
  };

  const trackCancelOpnLJbNo = async () => {
    const user = await fetchUserId();
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      window.Moengage.add_unique_user_id(userId);
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      window.Moengage.track_event(
        eventHelpers.CANCEL_OPN_L_JB_N
      );
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        p: 2
      }}
      onClick={() => handleJobPost()}
    >
      <Paper
        sx={{
          maxWidth: 600,
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
          overflow: "hidden",
          animation: "slideIn 0.3s ease-out"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <Box
          sx={{
            p: 2,
            background: '#2D5FA1',
            // background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)",
            color: "white",
            // background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)",
            // color: "white",
            position: "relative"
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <WarningIcon sx={{ fontSize: 28, color:'#ff6b6b' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, m: 0 }}>
              Cancel Open Job
            </Typography>
          </Box>
          <IconButton
            onClick={() => handleJobPost()}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "white",
              "&:hover": { background: "rgba(255, 255, 255, 0.1)" }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ p: 3 }}>
          {/* Alert Message */}
          <Alert 
            severity="warning" 
            sx={{ 
              mb: 3,
              "& .MuiAlert-message": { fontWeight: 500 }
            }}
          >
            Are you sure you want to cancel this open job? This action cannot be undone.
          </Alert>

          {/* Revoke Type Selection - Hidden */}
          <Box sx={{ display: 'none' }}>
            <FormControl fullWidth>
              <Select
                value="All Offer"
                onChange={(e) => {
                  setRevokeId(e.target.value.trim());
                  setReasonToRemove({
                    ...reasonToRemove,
                    revoke: e.target.value.trim(),
                  });
                }}
              >
                <MenuItem value="All Offer">All Offers</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Reason Selection */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#374151" }}>
              Reason for cancellation *
            </Typography>
            <Reasonselect
              reasonToRemove={reasonToRemove}
              setReasonToRemove={setReasonToRemove}
              title="Select Reason"
            />
            {reasonToRemoveError.reason && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <ErrorIcon sx={{ fontSize: 16, color: "#ef4444" }} />
                <Typography variant="caption" color="error">
                  {reasonToRemoveError.reason}
                </Typography>
              </Box>
            )}
          </Box>

          {/* Comments */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#374151" }}>
              {reasonToRemove?.reason === "Others" ? (
                <>
                  Additional Comments <span style={{ color: "#ef4444" }}>*</span>
                </>
              ) : (
                "Additional Comments (Optional)"
              )}
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              placeholder="Please provide any additional details..."
              value={reasonToRemove.comment || ""}
              onChange={(e) =>
                setReasonToRemove({
                  ...reasonToRemove,
                  comment: e.target.value
                })
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#f9fafb"
                }
              }}
            />
            {reasonToRemoveError.comment && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <ErrorIcon sx={{ fontSize: 16, color: "#ef4444" }} />
                <Typography variant="caption" color="error">
                  {reasonToRemoveError.comment}
                </Typography>
              </Box>
            )}
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 4 }}>
            <Button
              variant="outlined"
              onClick={() => handleJobPost()}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 600,
                borderColor: "#e5e7eb",
                color: "#6b7280",
                "&:hover": {
                  borderColor: "#d1d5db",
                  backgroundColor: "#f9fafb"
                }
              }}
            >
              No
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                pushEvent("Web_Cancel_OpenJob", {
                  page: "Cancel Open Job",
                  section: "Jobs",
                  ...jobPostRemoveId,
                  ...reasonToRemove
                });
                if (revokeId === "Pending Position") {
                  revokePendingPosition();
                } else {
                  revokeAllOffer();
                }
                trackCancelOpnLJbYes();
              }}
              disabled={Object.keys(reasonToRemoveError).length !== 0}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 600,
                backgroundColor: "#ef4444",
                "&:hover": {
                  backgroundColor: "#dc2626"
                },
                "&:disabled": {
                  backgroundColor: "#fca5a5",
                  color: "#ffffff"
                }
              }}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}


export default RevokeOpenJob;
